<template lang="pug">
    v-dialog(v-model="uploadBukti" persistent max-width="500px")
        v-card()
            v-card-title(class="headline grey lighten-2") Bukti Pelaporan
            v-card-text
                v-layout(row wrap class="mt-4")
                    v-flex(xs3 sm3 ) 
                        h3(class="headerSection") File Pelaporan:
                    v-flex(xs7 sm7 class="attachment" v-if="!docPelaporan || docPelaporan.size > 10000000")
                        v-file-input(:rules="rules" label="Hanya 1 file, max 10MB" v-model="docPelaporan")
                            template(v-slot:selection="{ text }" )
                                v-chip(small label color="primary")   {{ text }}
                    v-flex(xs7 sm7 class="attachmentName" v-if="docPelaporan && docPelaporan.size < 10000000") 
                        span {{docPelaporan.name}}
                        v-btn(icon color="red" @click="deleteDocPelaporan('docPelaporan')")
                            v-icon mdi-close
                    p(v-if="docPelaporan && docPelaporan != emptyUpload") <br/><br/>    
                    h3(style="text-align: center; font-weight:normal;") Dengan ini saya menyatakan pekerjaan dengan nomor {{ip.ipNo}} telah selesai
            v-card-actions
                v-spacer
                v-btn(text @click="closingModal()") Close
                v-btn(text :loading="uploadBukti2" color="blue darken-1" @click="uploadBukti2 = true" :disabled='!isComplete') Submit
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
    name: "UploadBuktiPelaporan",
    components: {

    },
    props: {
        ip: Object,
        uploadBukti: Boolean,
        uploadId: Number
    },
    data() {
        return {
            uploadBukti2: false,
            closing: false,
            docPelaporan: null,
            rules: [
                value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
            ],
            emptyUpload: new File([""], "", {
                        type: "",
                    })
        }
    },
    computed: {
        ...mapState(["API_URL", "dataUsers"]),
        isComplete(){
            return !!this.docPelaporan && this.docPelaporan != this.emptyUpload;
        },
    },
    methods: {
        deleteDocPelaporan(name){
            let id = this.uploadId.toString();      
            this.$store
                .dispatch("deleteFile", {
                    uploadId: id,
                    folderName: name,
                })
                .then(() => {
                    this.docPelaporan = null;
                })
                .catch(() => {
                    this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
                });
        },
        closingModal: function () {
            this.docPelaporan = null;
            this.$emit('interface', false)
        }
    },
    watch: {
        docPelaporan(params){
        if(params && params.size < 10000000){
            let formData = new FormData();
            formData.append('uploadId', this.uploadId );
            formData.append('docPendukung', params );
            axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
        }},
        uploadBukti2 (val) {
            if (!val) return;
            let formData = new FormData();
            formData.append('_id', this.ip._id);
            formData.append('uploadId', this.uploadId );

            const config = {
                method: "post",
                url: `${this.API_URL}/v1/requests/uploadNoExtend`,
                headers: {"Content-Type": "multipart/form-data", "Authorization": `Bearer ${this.$store.state.token}`},
                data: formData
            };
            axios(config).then(res => {
                this.$store.commit("temporaryData", res);
                this.closingModal();
                window.location.reload();
            });   
        }
    }
};
</script>